import { Directive, Input, OnChanges, SimpleChanges, TemplateRef, ViewContainerRef } from '@angular/core';
import { AuthorizationService, RequiredAuthorization } from '@app/shared/services/authorization.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Subscription } from 'rxjs';

@UntilDestroy()
@Directive({
  selector: '[portalIsAuthorized]',
  standalone: false,
})
export class IsAuthorizedDirective implements OnChanges {
  @Input('portalIsAuthorized')
  authorization: RequiredAuthorization;

  @Input('portalIsAuthorizedElse')
  elseTemplate?: TemplateRef<any>;

  @Input('portalIsAuthorizedThen')
  thenTemplate?: TemplateRef<any>;

  private subscription: Subscription | null = null;

  constructor(
    private authorizationService: AuthorizationService,
    private template: TemplateRef<any>,
    private viewContainer: ViewContainerRef
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if ('authorization' in changes && changes.authorization.currentValue != null) {
      this.subscribeWith(changes.authorization.currentValue);
    }
  }

  private subscribeWith(authorization: RequiredAuthorization) {
    if (this.subscription != null) {
      this.subscription.unsubscribe();
      this.subscription = null;
    }

    this.subscription = this.authorizationService
      .isAuthorized$(authorization)
      .pipe(untilDestroyed(this))
      .subscribe((isAuthorized) => {
        // If not cleared it could happen that some elements are displayed multiple times
        this.viewContainer.clear();

        if (isAuthorized) {
          this.viewContainer.createEmbeddedView(this.thenTemplate ?? this.template);
        } else if (this.elseTemplate != null) {
          this.viewContainer.createEmbeddedView(this.elseTemplate);
        }
      });
  }
}
